module.exports = __webpack_public_path__ + "public/img/read_overview.e0bdd5b.jpeg";